import {
	BNB,
	BTCB,
	BUSD,
	WBNB,
	
  ETH,
  BAT,
  USDC,
  WBTC,
  TUSD,
  ZRX,
  KNC,
  MANA,
  USDT,
  PAXUSD,
  COMP,
  LRC,
  LINK,
  YFI,
  BAL,
  GUSD,
  UNI,
  RENBTC,
  AAVE,
  UNIV2DAIETH,
  UNIV2WBTCETH,
  UNIV2USDCETH,
  UNIV2DAIUSDC,
  UNIV2ETHUSDT,
  UNIV2LINKETH,
  UNIV2UNIETH
} from '@makerdao/dai-plugin-mcd';

export default [
	{
    slug: 'bnb-a', // URL param
    symbol: 'BNB-A', // how it's displayed in the UI
    key: 'BNB-A', // the actual ilk name used in the vat
    gem: 'BNB', // the actual asset that's being locked
    currency: BNB, // the associated dai.js currency type
    networks: ['bsctestnet', 'bscmainnet']
  },
  {
    slug: 'bnb-b',
    symbol: 'BNB-B',
    key: 'BNB-B',
    gem: 'BNB',
    currency: BNB,
    networks: ['bsctestnet', 'bscmainnet']
  },
  {
    slug: 'eth-a',
    symbol: 'ETH-A',
    key: 'ETH-A',
    gem: 'ETH',
    currency: ETH,
    networks: ['hecotestnet', 'hecomainnet', 'bsctestnet', 'bscmainnet']
  },
  {
    slug: 'eth-b',
    symbol: 'ETH-B',
    key: 'ETH-B',
    gem: 'ETH',
    currency: ETH,
    networks: ['hecotestnet', 'hecomainnet', 'bsctestnet', 'bscmainnet']
  },
  {
    slug: 'eth-c',
    symbol: 'ETH-C',
    key: 'ETH-C',
    gem: 'ETH',
    currency: ETH,
    networks: ['hecotestnet1', 'hecomainnet1', 'bsctestnet1']
  },
  {
    slug: 'btcb-a',
    symbol: 'BTCB-A',
    key: 'BTCB-A',
    gem: 'BTCB',
    currency: BTCB,
    networks: ['bsctestnet', 'bscmainnet']
  },
  {
    slug: 'btcb-b',
    symbol: 'BTCB-B',
    key: 'BTCB-B',
    gem: 'BTCB',
    currency: BTCB,
    networks: ['bsctestnet', 'bscmainnet']
  },
  {
    slug: 'busd-a',
    symbol: 'BUSD-A',
    key: 'BUSD-A',
    gem: 'BUSD',
    currency: BUSD,
    networks: ['bsctestnet', 'bscmainnet']
  },
  {
    slug: 'busd-b',
    symbol: 'BUSD-B',
    key: 'BUSD-B',
    gem: 'BUSD',
    currency: BUSD,
    networks: ['bsctestnet1', 'bscmainnet']
  },
  
  
  {
    slug: 'bat-a',
    symbol: 'BAT-A',
    key: 'BAT-A',
    gem: 'BAT',
    currency: BAT,
    networks: ['kovan1', 'mainnet', 'testnet', 'rinkeby', 'ropsten', 'goerli', 'hecotestnet1']
  },
  {
    slug: 'usdc-a',
    symbol: 'USDC-A',
    key: 'USDC-A',
    gem: 'USDC',
    currency: USDC,
    networks: ['kovan1', 'mainnet', 'testnet1', 'rinkeby', 'ropsten', 'goerli'],
    decimals: 6
  },
  {
    slug: 'usdc-b',
    symbol: 'USDC-B',
    key: 'USDC-B',
    gem: 'USDC',
    currency: USDC,
    networks: ['kovan1', 'mainnet'],
    decimals: 6
  },
  {
    slug: 'weth-a',
    symbol: 'WETH-A',
    key: 'WETH-A',
    gem: 'WETH',
    currency: WBTC,
    networks: ['hecotestnet1'],
    decimals: 8
  },
  {
    slug: 'wbtc-a',
    symbol: 'WBTC-A',
    key: 'WBTC-A',
    gem: 'WBTC',
    currency: WBTC,
    networks: ['kovan1', 'mainnet', 'testnet', 'hecotestnet'],
    decimals: 8
  },
  {
    slug: 'tusd-a',
    symbol: 'TUSD-A',
    key: 'TUSD-A',
    gem: 'TUSD',
    currency: TUSD,
    networks: ['kovan1', 'mainnet']
  },
  {
    slug: 'knc-a',
    symbol: 'KNC-A',
    key: 'KNC-A',
    gem: 'KNC',
    currency: KNC,
    networks: ['mainnet', 'kovan1']
  },
  {
    slug: 'zrx-a',
    symbol: 'ZRX-A',
    key: 'ZRX-A',
    gem: 'ZRX',
    currency: ZRX,
    networks: ['mainnet', 'kovan1']
  },
  {
    slug: 'mana-a',
    symbol: 'MANA-A',
    key: 'MANA-A',
    gem: 'MANA',
    currency: MANA,
    networks: ['mainnet', 'kovan1']
  },
  {
    slug: 'usdt-a',
    symbol: 'USDT-A',
    key: 'USDT-A',
    gem: 'USDT',
    currency: USDT,
    networks: ['mainnet', 'kovan1'],
    decimals: 6
  },
  {
    slug: 'paxusd-a',
    symbol: 'PAXUSD-A',
    key: 'PAXUSD-A',
    gem: 'PAXUSD',
    currency: PAXUSD,
    networks: ['mainnet', 'kovan1']
  },
  {
    slug: 'comp-a',
    symbol: 'COMP-A',
    key: 'COMP-A',
    gem: 'COMP',
    currency: COMP,
    networks: ['mainnet', 'kovan1']
  },
  {
    slug: 'lrc-a',
    symbol: 'LRC-A',
    key: 'LRC-A',
    gem: 'LRC',
    currency: LRC,
    networks: ['mainnet', 'kovan1']
  },
  {
    slug: 'link-a',
    symbol: 'LINK-A',
    key: 'LINK-A',
    gem: 'LINK',
    currency: LINK,
    networks: ['mainnet', 'kovan1']
  },
  {
    slug: 'yfi-a',
    symbol: 'YFI-A',
    key: 'YFI-A',
    gem: 'YFI',
    currency: YFI,
    networks: ['mainnet', 'kovan1']
  },
  {
    slug: 'bal-a',
    symbol: 'BAL-A',
    key: 'BAL-A',
    gem: 'BAL',
    currency: BAL,
    networks: ['mainnet', 'kovan1']
  },
  {
    slug: 'gusd-a',
    symbol: 'GUSD-A',
    key: 'GUSD-A',
    gem: 'GUSD',
    currency: GUSD,
    networks: ['mainnet', 'kovan1']
  },
  {
    slug: 'uni-a',
    symbol: 'UNI-A',
    key: 'UNI-A',
    gem: 'UNI',
    currency: UNI,
    networks: ['mainnet', 'kovan1']
  },
  {
    slug: 'renbtc-a',
    symbol: 'RENBTC-A',
    key: 'RENBTC-A',
    gem: 'RENBTC',
    currency: RENBTC,
    networks: ['mainnet', 'kovan1']
  },
  {
    slug: 'aave-a',
    symbol: 'AAVE-A',
    key: 'AAVE-A',
    gem: 'AAVE',
    currency: AAVE,
    networks: ['mainnet', 'kovan1']
  },
  {
    slug: 'univ2daieth-a',
    symbol: 'UNIV2DAIETH-A',
    key: 'UNIV2DAIETH-A',
    gem: 'UNIV2DAIETH',
    currency: UNIV2DAIETH,
    networks: ['mainnet', 'kovan1']
  },
  {
    slug: 'univ2wbtceth-a',
    symbol: 'UNIV2WBTCETH-A',
    key: 'UNIV2WBTCETH-A',
    gem: 'UNIV2WBTCETH',
    currency: UNIV2WBTCETH,
    networks: ['mainnet']
  },
  {
    slug: 'univ2daiusdc-a',
    symbol: 'UNIV2DAIUSDC-A',
    key: 'UNIV2DAIUSDC-A',
    gem: 'UNIV2DAIUSDC',
    currency: UNIV2DAIUSDC,
    networks: ['mainnet']
  },
  {
    slug: 'univ2usdceth-a',
    symbol: 'UNIV2USDCETH-A',
    key: 'UNIV2USDCETH-A',
    gem: 'UNIV2USDCETH',
    currency: UNIV2USDCETH,
    networks: ['mainnet']
  },
  {
    slug: 'univ2ethusdt-a',
    symbol: 'UNIV2ETHUSDT-A',
    key: 'UNIV2ETHUSDT-A',
    gem: 'UNIV2ETHUSDT',
    currency: UNIV2ETHUSDT,
    networks: ['mainnet']
  },
  {
    slug: 'univ2linketh-a',
    symbol: 'UNIV2LINKETH-A',
    key: 'UNIV2LINKETH-A',
    gem: 'UNIV2LINKETH',
    currency: UNIV2LINKETH,
    networks: ['mainnet']
  },
  {
    slug: 'univ2unieth-a',
    symbol: 'UNIV2UNIETH-A',
    key: 'UNIV2UNIETH-A',
    gem: 'UNIV2UNIETH',
    currency: UNIV2UNIETH,
    networks: ['mainnet']
  }
];
